import React from "react";
import SignUpForm from "../Components/Forms/SignUpForm";

const Registration = () => {
  return (
    <>
      <SignUpForm />
    </>
  );
};

export default Registration;
